import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';

import SenhaService from '../services/SenhaService';
import Notificacao from '../comps/Notificacao';
import {useStore} from 'react-redux';
import CampanhaService from '../services/CampanhaService';
import TemaService from '../services/TemaService';

function ResetPassword() {

    const i18n = useStore().getState().i18n; 

    const [email, setEmail] = useState({email: ""})
    const [processando, setProcessando] = useState(false)
    const [mensagemProcessamento, setMensagemProcessamento] = useState(null)
    const [sucesso, setSucesso] = useState(false)

    
    useEffect(() => {
        let campanhaService = new CampanhaService()
        let campanha = campanhaService.campanhaCorrente()
        let temaService = new TemaService(campanha)
        temaService.aplicarTema('ENTRADA')
    })

    let resetPassword = (event) => {
        setProcessando(true)
        new SenhaService().enviarEmailRestauroSenha(email, (erro, sucesso) => {
            if(sucesso){
                setProcessando(false)
                setSucesso(true)
                setMensagemProcessamento(i18n.message("resetsenha.envioemail", "Foi enviado para o email informado as instruções para troca da sua senha"))
            }
            if(erro){
                setProcessando(false)
                if (erro.response && erro.response.data && erro.response.data.message) {
                    setMensagemProcessamento(erro.response.data.message)
                    setSucesso(false)
                } else {
                    setMensagemProcessamento(i18n.message("resetsenha.erro", "Falha ao tentar fazer o restauro da senha, entre em contato com o suporte ou tente novamente mais tarde"))
                    setSucesso(false)
                }
            }
        })
        event.preventDefault()
    }

    let onChange = (event) => {
        email.email = event.target.value
        setEmail(email)
    }

    return (
        
            <div>
                <h1 className="title foreground">{i18n.message("resetsenha.titulo", "Esqueceu sua senha?")}</h1>

                <div className="alerta-container">
                    <img src="restauro.png" className="alerta-container__img" alt="troca de senha"></img>
                </div>

                <p className="my-4 foreground">{i18n.message("resetsenha.instrucoes", "Digite seu e-mail no campo abaixo e clique em continuar. Lhe enviaremos por e-mail um link para a redefinição de sua senha.")}</p>

                <form onSubmit={resetPassword}>
                    <div className="field">
                        <div className="control">
                            <input type="email" required className="input" placeholder={i18n.message("resetsenha.email", "Digite seu email")} name="email" onChange={onChange}/>
                        </div>
                    </div>
                    <Link to="/" className="button">{i18n.message("geral.cancelar", "Cancelar")}</Link>
                    <input type="submit" value={i18n.message("geral.continuar", "Continuar")} className="button is-pulled-right" disabled={processando}/>
                </form>

                <div className="my-3">
                    
                    <Notificacao mensagem={mensagemProcessamento} sucesso={sucesso} />
                    
                   
                </div>
            </div>
       
    )
}

export default ResetPassword;